import groq from 'groq'

export const DesignQuery = groq`
design{...,}
`